var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.4C7.5 2.17909 7.72386 2 8 2C8.27614 2 8.5 2.17909 8.5 2.4V4H7.5V2.4Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.4C10.5 2.17909 10.7239 2 11 2C11.2761 2 11.5 2.17909 11.5 2.4V3.5H10.5V2.4Z",
    fill: "#002A69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.4C4.5 2.17909 4.72386 2 5 2C5.27614 2 5.5 2.17909 5.5 2.4V4H4.5V2.4Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3C11.8552 3 12.5822 3.5379 12.8682 4.29297C12.3428 4.15071 11.7583 4.2847 11.3457 4.69727L10.8301 5.21191C10.7981 5.23692 10.7668 5.26352 10.7373 5.29297L7.62695 8.40332C7.40793 8.62248 7.25815 8.90128 7.19727 9.20508L6.82715 11.0557C6.76161 11.3834 6.86441 11.7226 7.10059 11.959C7.33699 12.1954 7.67607 12.298 8.00391 12.2324L9.85449 11.8623C10.1585 11.8015 10.4379 11.6527 10.6572 11.4336L13 9.09082V12C13 13.1046 12.1046 14 11 14H5C3.89543 14 3 13.1046 3 12V5C3 3.89543 3.89543 3 5 3H11ZM4.5 9C4.22386 9 4 9.22386 4 9.5C4 9.77614 4.22386 10 4.5 10H5.5C5.77614 10 6 9.77614 6 9.5C6 9.22386 5.77614 9 5.5 9H4.5ZM8.26855 9.18945C8.27204 9.18441 8.27467 9.17876 8.27832 9.17383L8.33398 9.11035C8.30964 9.13474 8.28796 9.16135 8.26855 9.18945ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H7C7.27614 8 7.5 7.77614 7.5 7.5C7.5 7.22386 7.27614 7 7 7H4.5ZM4.5 5C4.22386 5 4 5.22386 4 5.5C4 5.77614 4.22386 6 4.5 6H8.5C8.77614 6 9 5.77614 9 5.5C9 5.22386 8.77614 5 8.5 5H4.5Z",
    fill: "#002A69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8603 7.82842L11.2441 6.21231L8.13425 9.3222C8.05448 9.40197 8.00011 9.50356 7.97799 9.61418L7.60789 11.4647L9.45839 11.0946C9.569 11.0725 9.67059 11.0181 9.75036 10.9383L12.8603 7.82842Z",
    fill: "#002A69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0525 5.40412C12.2757 5.18098 12.6374 5.18098 12.8606 5.40412L13.6686 6.21218C13.8918 6.43531 13.8918 6.79709 13.6686 7.02023L13.2646 7.42426L11.6485 5.80815L12.0525 5.40412Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.11aa55d0cd619c94b8a7d4d6ae5f9810.svg";
export { ForwardRef as ReactComponent };